import { json_headers, request } from './common';

export type IAppName = 'public-offers' | 'derbysoft';

const basePath = (appName: IAppName) => {
  switch (appName) {
    case 'derbysoft':
      return `${window.configs.API_HOST}/api/connections/${appName}/aws`;
    default:
      return `${window.configs.API_HOST}/api/${appName}/aws`;
  }
};

export interface IAwsJob {
  name: string;
  info: {
    count: number;
    delayed: number;
    active: number;
    failed: number;
  };
}

interface IAwsResponse<R> {
  status: number;
  message: string;
  result: R | null;
}

export const getJobs = (appName: IAppName): Promise<IAwsResponse<IAwsJob[]>> => {
  const url = `${basePath(appName)}/jobs`;
  return request(url, {
    method: `GET`,
    headers: json_headers,
  });
};

export const getJob = (appName: IAppName, jobName: string): Promise<IAwsResponse<IAwsJob>> => {
  const url = `${basePath(appName)}/jobs/${jobName}`;
  return request(url, {
    method: `GET`,
    headers: json_headers,
  });
};

export const restoreFailedJobs = (appName: IAppName, jobName: string): Promise<IAwsResponse<null>> => {
  const url = `${basePath(appName)}/jobs/${jobName}/restore/failed`;
  return request(url, {
    method: `POST`,
    headers: json_headers,
  });
};
